// Change only this report while printing, and restore the reader's open sections.
export function printEvaluationReport(root, mode = 'summary', printWindow = window) {
  if (!root) return () => {};
  const previousMode = root.dataset.printMode;
  const disclosures = [...root.querySelectorAll('details')].map(element => ({ element, open: element.open }));
  root.dataset.printMode = mode === 'full' ? 'full' : 'summary';
  if (mode === 'full') disclosures.forEach(({ element }) => { element.open = true; });
  let restored = false;
  const restore = () => {
    if (restored) return;
    restored = true;
    printWindow.removeEventListener('afterprint', restore);
    if (previousMode === undefined) delete root.dataset.printMode;
    else root.dataset.printMode = previousMode;
    disclosures.forEach(({ element, open }) => { element.open = open; });
  };
  printWindow.addEventListener('afterprint', restore, { once: true });
  try { printWindow.print(); } catch (error) { restore(); throw error; }
  return restore;
}
